module.exports = __webpack_public_path__ + "assets/img/bannew.8aa7e736.png";